import Vue from 'vue';
import Vuex from 'vuex';
import ApiCaller from "../utils/apicaller";
import types from "./types";
import constant from "../utils/constant"
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {},
    getters: {
        isUserRegister: state => {
            return state.showCelebname ? state.showCelebname.data.celebrity_id : 0
        }
    },
    mutations: {

    },
    actions: {
        verifyCelebrity({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/login', 'post', payload)
        },

        availableRequests({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/available_requests', 'get')
        },

        acceptReject({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/request_response', 'post', payload)
        },

        respondedRequest({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/responded_requests', 'get', payload)
        },

        totalUploadedVideos({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/total_videos_uploaded', 'get')
        },

        celebProfile({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/profile', 'get')
        },

        celebAcceptedMessages({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/accepted', 'get')
        },

        updateCelebProfile({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/profile', 'post', payload)
        },

        uploadVideo({ commit }, { type, payload }) {
            return ApiCaller('/celebrity/upload', 'post', payload)
        },

        playVideo({ commit }, { type, payload }) {
            return ApiCaller(`/video_response/${payload}`, 'get')
        },

    }
})

export default store;